import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SuperAdminSidebar from "./Components/SuperAdminSidebar";
import appDetails_graph from "../../assets/images/appDetails_graph.png";
import user_login_frequency_graph from "../../assets/images/user_login_frequency_graph.png";
import westside_image from "../../assets/images/westside_image.png";
import AppDetailOfSite from "./Components/AppDetailOfSite";
import SuperAdminSearchBar from "./Components/SuperAdminSearchBar";

const AppDetails = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [siteName, setSiteName] = useState(null);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SuperAdminSearchBar
            categoryName="App Details"
            route="/super-admin/app-details"
          />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <SuperAdminSidebar />}
        </div>
      </div>

      {siteName ? (
        <AppDetailOfSite siteName={siteName} />
      ) : (
        <div>
          <div className="ml-4 mt-8 w-[70%]">
            <img
              src={appDetails_graph}
              alt="app details graph"
              className="w-full"
            />
          </div>
          <div className="ml-4 mt-8 w-[70%]">
            <img
              src={user_login_frequency_graph}
              alt="app details graph"
              className="w-full"
            />
          </div>
          <div className="ml-4 mt-8 bg-[#F9F9F9] rounded-lg w-[80%] p-4 my-8">
            <p className="text-[16px] font-bold">Client Details</p>
            <p className="text-[12px] mt-2">Client Interaction details</p>
            <div className="flex flex-col justify-start w-[100%] mt-4">
              <div className="flex w-full config-col">
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 super-admin-card-02"
                  onClick={() => setSiteName("westside")}
                >
                  <img
                    src={westside_image}
                    alt="westside_image"
                    className="w-6"
                  />
                  <p className="text-[14px] font-bold ml-2">Westside</p>
                </div>
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 ml-10 super-admin-card-02"
                  onClick={() => setSiteName("Home Center")}
                >
                  <img src={westside_image} alt="Home Center" className="w-6" />
                  <p className="text-[14px] font-bold ml-2">Home Center</p>
                </div>
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 ml-10 super-admin-card-02"
                  onClick={() => setSiteName("Shoppers Stop")}
                >
                  <img
                    src={westside_image}
                    alt="Shoppers Stop"
                    className="w-6"
                  />
                  <p className="text-[14px] font-bold ml-2">Shoppers Stop</p>
                </div>
              </div>
              <div className="flex w-full config-col">
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 super-admin-card-02"
                  onClick={() => setSiteName("HP")}
                >
                  <img src={westside_image} alt="HP" className="w-6" />
                  <p className="text-[14px] font-bold ml-2">HP</p>
                </div>
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 ml-10 super-admin-card-02"
                  onClick={() => setSiteName("Indian Oil")}
                >
                  <img src={westside_image} alt="Indian Oil" className="w-6" />
                  <p className="text-[14px] font-bold ml-2">Indian Oil</p>
                </div>
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 ml-10 super-admin-card-02"
                  onClick={() => setSiteName("Uniliver")}
                >
                  <img src={westside_image} alt="Uniliver" className="w-6" />
                  <p className="text-[14px] font-bold ml-2">Uniliver</p>
                </div>
              </div>
              <div className="flex w-full config-col">
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 super-admin-card-02"
                  onClick={() => setSiteName("Vi")}
                >
                  <img src={westside_image} alt="Vi" className="w-6" />
                  <p className="text-[14px] font-bold ml-2">Vi</p>
                </div>
                <div
                  className="bg-white flex items-center p-3 w-[30%] cursor-pointer rounded-lg mt-4 ml-10 super-admin-card-02"
                  onClick={() => setSiteName("KFC")}
                >
                  <img src={westside_image} alt="KFC" className="w-6" />
                  <p className="text-[14px] font-bold ml-2">KFC</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <AppDetailOfSite siteName={siteName} /> */}
    </div>
  );
};

export default AppDetails;
